import React from 'react';

import { useAPIData } from 'dal/useAPIData';

const loadScripts = ({ orgInfo }) => {
  if (
    !orgInfo?.aptlyListings?.customJavaScript ||
    !orgInfo?.aptlyListings?.enableCustomJavaScript
  ) {
    return; // disabled!
  }

  try {
    if (document.CUSTOM_SCRIPTS_LOADED) return;
    let customJS = orgInfo?.aptlyListings?.customJavaScript;
    let match;

    // Handle external scripts first
    const externalScriptRegex = /<script[^>]*src\s*=\s*["']([^"']+)["'][^>]*><\/script>/gi;
    while ((match = externalScriptRegex.exec(customJS)) !== null) {
      const src = match[1]?.trim();
      if (src) {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        document.head.appendChild(script);
      }
    }

    // Handle inline scripts
    const scriptRegex = /<script[^>]*>([\s\S]*?)<\/script>/gi;
    while ((match = scriptRegex.exec(customJS)) !== null) {
      const jsContent = match[1]?.trim();
      if (jsContent) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.text = jsContent;
        document.head.appendChild(script);
      }
    }

    document.CUSTOM_SCRIPTS_LOADED = true;
  } catch (error) {
    console.error('Error executing custom JavaScript:', error);
  }
};

export const useContextAndScript = ({ orgId }) => {
  const [orgInfo] = useAPIData(
    'context.LOAD_ORG_CONTEXT',
    !orgId ? undefined : { contextId: orgId },
    { reFetchWhen: [orgId], disableEmptyArgs: true }
  );

  React.useEffect(() => {
    loadScripts({ orgInfo });
  }, [orgInfo?.aptlyListings?.customJavaScript, orgInfo?.aptlyListings?.enableCustomJavaScript]);
};

export default ({ orgInfo }) => {
  React.useEffect(() => {
    loadScripts({ orgInfo });
  }, [orgInfo?.aptlyListings?.customJavaScript, orgInfo?.aptlyListings?.enableCustomJavaScript]);
};
